import { createReducer, on } from "@ngrx/store";
import { ProposalBillingItem } from "app/entities";
import { Error, Status } from "../AppState";
import { logoutUserSuccess } from "../user/user.actions";
import {
    billProposalBillingItem,
    billProposalBillingItemFailure,
    billProposalBillingItemSuccess,
    clearProposalBillingItems,
    loadProposalBillingItems,
    loadProposalBillingItemsFailure,
    loadProposalBillingItemsSuccess,
    payProposalBillingItem,
    payProposalBillingItemFailure,
    payProposalBillingItemSuccess,
} from "./proposal-billing-item.actions";

export interface ProposalBillingItemState {
    proposalId: number | null;
    items: ProposalBillingItem[];
    error: Error | null;
    status: Status | null;
}

export const initialState: ProposalBillingItemState = {
    proposalId: null,
    items: [],
    error: null,
    status: {
        statusName: 'pending',
        isError: false,
        isFinished: false
    },
};

const loadingStatus = {
    statusName: 'loading',
    isError: false,
    isFinished: false
};

const successStatus = {
    statusName: 'success',
    isError: false,
    isFinished: true
};

export const proposalBillingItemReducer = createReducer(
    initialState,
    on(loadProposalBillingItems, (state, { proposalId }) => ({
        ...state,
        proposalId,
        items: state.proposalId === proposalId ? state.items : [],
        status: loadingStatus,
        error: null,
    })),
    on(clearProposalBillingItems, () => initialState),
    on(billProposalBillingItem, payProposalBillingItem, (state) => ({
        ...state,
        status: loadingStatus,
    })),
    on(loadProposalBillingItemsSuccess, (state, { proposalId, items }) => ({
        ...state,
        proposalId,
        items,
        status: successStatus,
        error: null,
    })),
    on(billProposalBillingItemSuccess, payProposalBillingItemSuccess, (state, { item }) => ({
        ...state,
        items: state.items.map(current => current.id === item.id ? item : current),
        status: successStatus,
        error: null,
    })),
    on(loadProposalBillingItemsFailure, billProposalBillingItemFailure, payProposalBillingItemFailure, (state, { error }) => ({
        ...state,
        error,
        status: {
            statusName: 'error',
            isError: true,
            isFinished: true
        },
    })),
    on(logoutUserSuccess, () => initialState),
);
